const normalizeGroup = (group) => {
    const { adults = 0, kids = 0, infants = 0, ages } = group;
 
    const result = {
        adults: adults,
        kids: kids,
        infants: infants,
        kidsAges: [],
    };


    if (kids && ages?.length) {
        result.kidsAges = _.chain(ages)
            .map((age) => +age)
            .filter((age) => age > 1)
            .value()
            .sort();
    }

    return result;
}

export default (tourCriteria) => {
    const element = tourCriteria.get('touristGroup');
    if (!element) return {};

    const parsedGroup = element.toJSON();

    if (parsedGroup?.touristsByRooms?.length > 0) {
        const rooms = [{
            touristGroup: normalizeGroup(parsedGroup),
        }];

        parsedGroup.touristsByRooms.forEach(room => {
            rooms.push({ touristGroup: normalizeGroup(room) });
        });

        return {
            rooms,
            touristGroup: normalizeGroup(parsedGroup),
        }
    }

    return {
        touristGroup: normalizeGroup(parsedGroup)
    }
};